/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ActionNodeDTO,
    ActionNodeDTOFromJSON,
    ActionNodeDTOFromJSONTyped,
    ActionNodeDTOToJSON,
} from './ActionNodeDTO';

/**
 * 
 * @export
 * @interface PrivilegeDTO
 */
export interface PrivilegeDTO {
    /**
     * 
     * @type {string}
     * @memberof PrivilegeDTO
     */
    resource?: string;
    /**
     * 
     * @type {Array<ActionNodeDTO>}
     * @memberof PrivilegeDTO
     */
    actions?: Array<ActionNodeDTO>;
}

export function PrivilegeDTOFromJSON(json: any): PrivilegeDTO {
    return PrivilegeDTOFromJSONTyped(json, false);
}

export function PrivilegeDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): PrivilegeDTO {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'resource': !exists(json, 'resource') ? undefined : json['resource'],
        'actions': !exists(json, 'actions') ? undefined : ((json['actions'] as Array<any>).map(ActionNodeDTOFromJSON)),
    };
}

export function PrivilegeDTOToJSON(value?: PrivilegeDTO | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'resource': value.resource,
        'actions': value.actions === undefined ? undefined : ((value.actions as Array<any>).map(ActionNodeDTOToJSON)),
    };
}

